import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import DataGrid, { Column, Selection, Paging, Pager } from 'devextreme-react/ui/data-grid';
import UserInfoColumn from "../../../Shared/UserInfoColumn";
import LoadingOverlay from "../../../Shared/LoadingOverlay";
import { Button, Popup, TextBox, DropDownBox, TreeView } from 'devextreme-react';
import validaciones from "../../../../helpers/validaciones";
import { getTrabajadoresAchs, getAllRolesByAchsAction, setRolesTrabajadores, getRolesUserSelected } from "./action"
import TableFilter from "../../../Shared/tableFilter.jsx";

class TablaTrabajadores extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupVisible: false,
      dataSelected: null,
      treeBoxValue: [],
    };
    this.treeView = null;
    this.tableRef = React.createRef();
  }

  componentWillMount = () => {
    this.props.dispatch(getTrabajadoresAchs())
    this.props.dispatch(getAllRolesByAchsAction())
  }

  componentDidUpdate = (prev) => {
    if (prev.getRolesUserSelected !== this.props.getRolesUserSelected && this.props.getRolesUserSelected) {
      //this.setDataSelected(this.props.getRolesUserSelected)
    }
  }

  treeViewRender = () => {
    return (
      <TreeView
        dataSource={this.props.listaRoles}
        ref={(ref) => this.treeView = ref}
        dataStructure={'plain'}
        keyExpr={'newId'}
        parentIdExpr={'categoryId'}
        selectionMode={'multiple'}
        showCheckBoxesMode={'normal'}
        selectNodesRecursive={true}
        displayExpr={'Name'}
        selectByClick={true}
        expandAllEnabled
        onContentReady={this.syncTreeViewSelection}
        onItemSelectionChanged={this.treeView_itemSelectionChanged}
      />
    );
  }

  syncTreeViewSelection = (e) => {
    let treeView = (e.component.selectItem && e.component) || (this.treeView && this.treeView.instance);

    if (treeView) {
      if (e.value === null) {
        treeView.unselectAll();
      } else {
        //let values = e.value || this.state.treeBoxValue;
        var values = [];
        this.state.dataSelected.roles.forEach(e => {
          if (this.props.listaRoles.find(ee => ee.Id === e.id && !ee.categoryId)) {
            if (!e.achsOfficeList.length) {
              values.push(e.id)
            } else if (e.achsOfficeList && e.achsOfficeList.length) {
              e.achsOfficeList.forEach(ee => {
                values.push(e.id + "_" + ee)
              })
            }
          }
        })
        values && values.forEach(function (value) {
          treeView.selectItem(value);
        });
      }
    }

    if (e.value !== undefined) {
      this.setState({
        treeBoxValue: e.value
      });
    }
  }

  treeView_itemSelectionChanged = (e) => {
    let _text = e.component.getSelectedNodesKeys()
    _text = _text.map(e => Number(e.toString().split("_")[0]))
    this.setState({
      treeBoxValue: [...new Set(_text)]
    });
  }

  setDataSelected = (data) => {
    const _listaroles = this.props.listaRoles;
    const _roles = data.roles && data.roles.length ? data.roles.map(e => _listaroles.find(ee => ee.Id === e.id && !ee.categoryId) && e.id).filter(f => f) : [];
    //var _roles = [];
    /*data.roles.forEach(e => {
      if(this.props.listaRoles.find(ee => ee.Id === e.id && !ee.categoryId)){
        if(!e.achsOfficeList){
          _roles.push(e.id)
        }else if(e.achsOfficeList && e.achsOfficeList.length){
          e.achsOfficeList.forEach(ee => {
            _roles.push(e.id+"_"+ee)
          })
        }
      }
    })*/
    this.setState({
      popupVisible: true,
      dataSelected: data,
      treeBoxValue: _roles
    })
  }

  handleSave = () => {
    let _data = {};
    if (!this.treeView) return;
    const selectedNodes = this.treeView.instance.getSelectedNodesKeys();
    let rolesSelected = selectedNodes.map(e => { let a = e.toString().split("_"); return Number(a[0]) });
    rolesSelected = [...new Set(rolesSelected)];
    _data.Roles = rolesSelected.map(e => {
      let _offices = selectedNodes.filter(ee => typeof ee === "string" && ee.includes(e.toString() + "_")).map(ee => Number(ee.split("_")[1]));
      return {
        IdRol: e,
        AchsOffices: _offices
      }
    })
    _data.RelationTypeCode = this.state.dataSelected.relationTypeCode;
    _data.Rut = this.state.dataSelected.rut;
    this.props.dispatch(setRolesTrabajadores(_data, this.handleClosePopup))
  }

  handleClosePopup = () => {
    this.setState({ popupVisible: false, dataSelected: null, treeBoxValue: [] })
  }

  handleFilterChange = (text) => {
    this.tableRef.searchByText(text);
  }

  render() {

    return (
      <React.Fragment>
        {this.props.isLoading && <LoadingOverlay />}
        <TableFilter
          placeholder="Buscar trabajador por nombre o rut"
          onChange={this.handleFilterChange}
          show
        //selectedMainFilter={this.props.selectedTipoSolicitud}
        />
        <DataGrid
          ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
          width={"100%"}
          id={'grid-container'}
          dataSource={this.props.listaTrabajadores}
          showBorders={true}
          onInitialized={this.onInitialized}
          className="custom-table trabajadores"
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          rowAlternationEnabled
          hoverStateEnabled={false}
          activeStateEnabled={false}
          focusStateEnabled={false}
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin solicitudes");
              noDataSpan.appendChild(element);
            }
          }}
          noDataText=""
        >
          <Selection mode={'multiple'} deferred={true} showCheckBoxesMode />
          <Column
            dataField={"name"}
            allowFiltering
            caption={'Trabajador'}
            cellTemplate={(element, row) => (
              <React.Fragment >
                {
                  ReactDOM.render(<UserInfoColumn
                    nombre={row.data.name}
                    rut={row.data.rut}
                  />, element)
                }
              </React.Fragment>
            )}
          />
          <Column
            allowFiltering
            dataField={'rut'}
            visible={false}
          />
          <Column
            allowFiltering={false}
            caption={'Relación'}
            dataField={'relation'}
          />
          <Column
            allowFiltering={false}
            caption={'Roles'}
            dataField={'roles'}
            cellTemplate={(element, row) => {
              let listaRoles = "";
              if (row.data.roles && row.data.roles.length) {
                row.data.roles.forEach((e, i) => {
                  listaRoles += e.description;
                  if (i !== (row.data.roles.length - 1)) listaRoles += ","
                });
              }
              return <React.Fragment >
                {
                  ReactDOM.render(listaRoles, element)
                }
              </React.Fragment>
            }}
          />
          <Column
            allowFiltering={false}
            caption={''}
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <Button
                  style={{ margin: "auto", display: "grid" }}
                  disabled={row.data.Status === 1}
                  className="slimButton"
                  text="Editar"
                  type="success"
                  onClick={() => this.props.dispatch(getRolesUserSelected(row.data, this.setDataSelected))}
                />
                , element
              );
            }}
          />
          <Paging
            defaultPageSize={20}
          />
          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />
        </DataGrid>
        <Popup
          className={'popup gestionRoles'}
          visible={this.state.popupVisible}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showTitle={true}
          title={'Editar roles ACHS'}
          width={700}
          height={440}
          onHiding={this.handleClosePopup}
        >
          <React.Fragment>
            <div style={{ marginTop: -15 }}>
              {this.props.isLoading && <LoadingOverlay />}
              <div className="row">
                <div className="col-12">
                  <h3><p className="text-left success">Trabajador</p></h3>
                  <TextBox value={this.state.dataSelected && this.state.dataSelected.name}
                    disabled={true} />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <h3><p className="text-left success">Rut</p></h3>
                  <TextBox value={this.state.dataSelected && this.state.dataSelected.rut}
                    disabled={true} />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <h3><p className="text-left success">Relación</p></h3>
                  <TextBox value={this.state.dataSelected && this.state.dataSelected.relation}
                    disabled={true} />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <h3><p className="text-left success">Roles ACHS</p></h3>
                  <DropDownBox
                    value={this.state.treeBoxValue}
                    valueExpr={'newId'}
                    displayExpr={'Name'}
                    placeholder={'Select a value...'}
                    showClearButton={true}
                    dataSource={this.props.listaRoles}
                    onValueChanged={this.syncTreeViewSelection}
                    contentRender={this.treeViewRender}
                    text={'Sandra Johnson'}
                  />
                </div>
              </div>
              <div className="button-row">
                <div>
                  <Button text="Cancelar" onClick={this.handleClosePopup} />
                </div>

                <div>
                  <Button text="Guardar" type="success" onClick={this.handleSave} disabled={!this.treeView || this.props.isLoading} />
                </div>
              </div>
            </div>
          </React.Fragment>
        </Popup>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorTrabajadoresAchs.isLoading,
  listaTrabajadores: state.mantenedorTrabajadoresAchs.listaTrabajadores,
  listaRoles: state.mantenedorTrabajadoresAchs.listaRoles,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TablaTrabajadores);
